import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class TagsService {

  constructor(private http: HttpClient) {}
  addTag(body) {
    return this.http.post<ApiResponseModel>('api/tag', body);
  }
  getTags() {
    return this.http.get<ApiResponseModel>('api/tag');
  }
  getTagById(id) {
    return this.http.get<ApiResponseModel>('/api/tag/' + id);
  }
  editTag(body, id) {
    return this.http.patch<ApiResponseModel>('/api/tag/' + id, body);
  }

}
